import { render, staticRenderFns } from "./Pods.vue?vue&type=template&id=49846419&scoped=true&"
import script from "./Pods.vue?vue&type=script&lang=ts&"
export * from "./Pods.vue?vue&type=script&lang=ts&"
import style0 from "./Pods.vue?vue&type=style&index=0&id=49846419&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49846419",
  null
  
)

export default component.exports